import { Component, Input } from '@angular/core';

@Component({
  selector: 'search-tooltip',
  templateUrl: './search-tooltip.component.html',
  standalone: false,
})
export class SearchTooltipComponent {
  @Input() toolinfo: string;
  showinfo = false;

  toggle(showinfo: boolean) {
    this.showinfo = showinfo;
  }
}
